import { CalculatedDeltas, RawUIPreferences, UIPreferences } from 'common/types/account';

export const prefillUIPreferences = ({ decimalsEnabled, showBarValue, brandColors }: RawUIPreferences): UIPreferences => ({
  decimalsEnabled: typeof decimalsEnabled === 'boolean' ? decimalsEnabled : true,
  calculateDeltas: CalculatedDeltas.FIRST_LAST,
  showBarValue: showBarValue || false,
  brandColors: brandColors || {},
});
